// @flow
import CheckoutErrors from '@components/cart/CheckoutErrors';

const checkmarkIcon = '/images/checkout_checkmark_icon.png';

type InputRefType = {
  current: null | React.ElementRef<'input'>
};

type SelectRefType = {
  current: null | React.ElementRef<'select'>
};

type RefType = SelectRefType | InputRefType;
type ErrorFieldType = string;

type PropsType = {
  onSubmitClick: (fields: Object, allowNext?: boolean) => void,
  active: boolean,
  completed: boolean,
  editStep: (e: SyntheticMouseEvent<HTMLLinkElement>, name: string) => void,
  stepName: string,
  displayStep: boolean,
  errorFields: Array<ErrorFieldType>
};

type StateType = {
  shippingAddressType: string
};

class CheckoutStepThree extends React.Component<PropsType, StateType> {
  shippingAddressCompanyRef: InputRefType;
  shippingAddressRef: InputRefType;
  shippingAddress2Ref: InputRefType;
  shippingCityRef: InputRefType;
  shippingStateRef: SelectRefType;
  shippingZipCodeRef: InputRefType;
  allRefs: Array<RefType>;

  constructor (props: PropsType) {
    super(props);

    this.shippingAddressCompanyRef = React.createRef();
    this.shippingAddressRef = React.createRef();
    this.shippingAddress2Ref = React.createRef();
    this.shippingCityRef = React.createRef();
    this.shippingStateRef = React.createRef();
    this.shippingZipCodeRef = React.createRef();
    this.allRefs = [
      this.shippingAddressCompanyRef,
      this.shippingAddressRef,
      this.shippingAddress2Ref,
      this.shippingCityRef,
      this.shippingStateRef,
      this.shippingZipCodeRef
    ];
  }

  state = {
    shippingAddressType: 'residence'
  };

  handleShippingAddressTypeChange = (
    e: SyntheticInputEvent<HTMLInputElement>
  ) => {
    this.setState({
      shippingAddressType: e.target.value
    });
  };

  handleButtonClick = (e: SyntheticMouseEvent<HTMLInputElement>) => {
    e.preventDefault();

    const fields = {
      shipping_bus_or_res: this.state.shippingAddressType
    };

    this.allRefs.forEach((ref: RefType) => {
      const el = ref.current;
      if (!el || !el.name) {
        return;
      }

      fields[(el.name.match(/order\[(.*)\]/) || '')[1]] = el.value;
    });

    this.props.onSubmitClick({ order: fields });
  };

  render () {
    const {
      active,
      completed,
      onSubmitClick,
      editStep,
      stepName,
      displayStep,
      errorFields
    } = this.props;

    if (displayStep) {
      return (
        <div id="checkoutBox" className="shipBox" style={{}}>
          <h3>
            <img
              alt="Checkmark_icon"
              id="shipping_checked"
              src={checkmarkIcon}
              style={{ display: completed ? 'block' : 'none' }}
            />
            Your Shipping Information:
            <a
              href="#"
              id="shipping_edit_link"
              onClick={(e) => editStep(e, stepName)}
              style={{ display: completed ? 'block' : 'none' }}>
              edit
            </a>
          </h3>
          <div id="checkoutContent">
            <div
              id="shipping_checkout"
              style={{ display: active ? 'block' : 'none' }}>
              {/* commented out for international shipping from here <p style="border-bottom:solid 1px #C7DCF2; padding-bottom:10px; margin-bottom:5px;"><!-- For your security, your order will only be shipped to your billing address, or an alternate address which is on file with
      your payment card issuer. If you would like to ship to an address other than your billing address, contact your card issuer
      (using the 1-800 number on the back of your card or on your monthly statement) after placing your order, and have
      your chosen ship-to address placed in your account record (ask to have your ship-to address placed in a memo field if
      the card issuer does not allow a second address)</p>
    <p>
      Enter your shipping address. Lumera Diamonds is unable to ship to a P.O. Box or to an address outside the U.S.
    </p> to here */}
              <div className="shipping">
                <dl>
                  <div>
                    <dt>
                      <label>This is a</label>
                    </dt>
                    <dd className="shipCheck">
                      <input
                        id="order_shipping_bus_or_res_business"
                        name="order[shipping_bus_or_res]"
                        onChange={this.handleShippingAddressTypeChange}
                        defaultValue="business"
                        type="radio"
                      />{' '}
                      Business &nbsp;&nbsp;&nbsp;
                      <input
                        defaultChecked="checked"
                        id="order_shipping_bus_or_res_residence"
                        name="order[shipping_bus_or_res]"
                        onChange={this.handleShippingAddressTypeChange}
                        defaultValue="residence"
                        type="radio"
                      />{' '}
                      Residence
                    </dd>
                  </div>
                  {this.state.shippingAddressType === 'business' ? (
                    <div id="shipping_company_row">
                      <dt>Company:</dt>
                      <dd>
                        <input
                          id="order_shipping_company"
                          name="order[shipping_company]"
                          size={30}
                          type="text"
                          ref={(el) => {
                            this.shippingAddressCompanyRef.current = el;
                          }}
                        />
                      </dd>
                    </div>
                  ) : null}
                  <div>
                    <dt>
                      <label htmlFor="order_shipping_address">
                        Address (1):
                      </label>
                    </dt>
                    <dd>
                      <input
                        autoComplete="address-line1"
                        id="order_shipping_address"
                        name="order[shipping_address]"
                        size={30}
                        type="text"
                        ref={this.shippingAddressRef}
                      />
                    </dd>
                  </div>
                  <div>
                    <dt>
                      <label htmlFor="order_shipping_address2">
                        Address (2):
                      </label>
                    </dt>
                    <dd>
                      <input
                        autoComplete="address-line2"
                        id="order_shipping_address2"
                        name="order[shipping_address2]"
                        size={30}
                        type="text"
                        ref={this.shippingAddress2Ref}
                      />
                    </dd>
                  </div>
                  <div>
                    <dt>
                      <label htmlFor="order_shipping_city">City:</label>
                    </dt>
                    <dd>
                      <input
                        autoComplete="address-level2"
                        id="order_shipping_city"
                        name="order[shipping_city]"
                        size={30}
                        type="text"
                        ref={this.shippingCityRef}
                      />
                    </dd>
                  </div>
                  <div>
                    <dt>
                      <label htmlFor="order_shipping_state">State:</label>
                    </dt>
                    <dd>
                      <select
                        id="order_shipping_state"
                        name="order[shipping_state]"
                        ref={this.shippingStateRef}>
                        <option value="">- -</option>
                        <option value="AK">AK</option>
                        <option value="AL">AL</option>
                        <option value="AR">AR</option>
                        <option value="AZ">AZ</option>
                        <option value="CA">CA</option>
                        <option value="CO">CO</option>
                        <option value="CT">CT</option>
                        <option value="DC">DC</option>
                        <option value="DE">DE</option>
                        <option value="FL">FL</option>
                        <option value="GA">GA</option>
                        <option value="HI">HI</option>
                        <option value="IA">IA</option>
                        <option value="ID">ID</option>
                        <option value="IL">IL</option>
                        <option value="IN">IN</option>
                        <option value="KS">KS</option>
                        <option value="KY">KY</option>
                        <option value="LA">LA</option>
                        <option value="MA">MA</option>
                        <option value="MD">MD</option>
                        <option value="ME">ME</option>
                        <option value="MI">MI</option>
                        <option value="MN">MN</option>
                        <option value="MO">MO</option>
                        <option value="MS">MS</option>
                        <option value="MT">MT</option>
                        <option value="NC">NC</option>
                        <option value="ND">ND</option>
                        <option value="NE">NE</option>
                        <option value="NH">NH</option>
                        <option value="NJ">NJ</option>
                        <option value="NM">NM</option>
                        <option value="NV">NV</option>
                        <option value="NY">NY</option>
                        <option value="OH">OH</option>
                        <option value="OK">OK</option>
                        <option value="OR">OR</option>
                        <option value="PA">PA</option>
                        <option value="RI">RI</option>
                        <option value="SC">SC</option>
                        <option value="SD">SD</option>
                        <option value="TN">TN</option>
                        <option value="TX">TX</option>
                        <option value="UT">UT</option>
                        <option value="VA">VA</option>
                        <option value="VT">VT</option>
                        <option value="WA">WA</option>
                        <option value="WI">WI</option>
                        <option value="WV">WV</option>
                        <option value="WY">WY</option>
                      </select>
                    </dd>
                    <div id="shipping-zip-code">
                      <dt>
                        <label htmlFor="order_shipping_zip_code">Zip:</label>
                      </dt>
                      <dd>
                        <input
                          autoComplete="postal-code"
                          id="order_shipping_zip_code"
                          name="order[shipping_zip_code]"
                          pattern="[0-9]*"
                          size={8}
                          type="text"
                          ref={this.shippingZipCodeRef}
                        />
                      </dd>
                    </div>
                  </div>
                  <input
                    className="blue button"
                    defaultValue="Enter"
                    type="button"
                    onClick={this.handleButtonClick}
                  />
                  <br />
                  <br />

                  <CheckoutErrors errorFields={errorFields} />
                </dl>
              </div>
              <input
                id="order_step"
                name="order[step]"
                defaultValue="shipping"
                type="hidden"
              />
              <div id="shippingDetails">
                <p>
                  <span className="blue">
                    An adult's signature is required at delivery.
                  </span>
                  <br />
                  This is true even if you have waived signature requirements
                  with FedEx.
                </p>
                <p>
                  <span className="blue">Your purchase is secure,</span> and
                  will be shipped fully insured, in a secure, discrete package.
                </p>
              </div>
              <div style={{ clear: 'both' }} />
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default CheckoutStepThree;
